export const dhrAssistancePhoneNumber = "1-877-416-0931"
export const dhrAssistanceEmail = "DHRAssistanceLine@SCANAEnergy.com"
export const dhrAssistanceFaxNumber = "1-866-270-1957"
